import React from 'react';

import Focusable from './Focusable';

const InvisibleButton = ({
	focus_ref=null,
	has_focus=false,
	on_select=null,
	left='auto',
	right='auto',
	top='auto',
	bottom='auto',
	width,
	height,
}) => (
	<div style={{
		position: 'absolute',
		left: left,
		right: right,
		top: top,
		bottom: bottom,
		width: width,
		height: height,
	}}>
		<Focusable
			has_focus={has_focus}
			focus_ref={focus_ref}
			on_select={on_select}
		>
			<div onClick={on_select} style={{width: width, height: height}}></div>
		</Focusable>
	</div>
)

export default InvisibleButton


// WEBPACK FOOTER //
// ./src/InvisibleButton.js